// compass cross-bearing: intersection of two great-circle bearings (Veness)
const R = Math.PI / 180;
export const nv = (v) => { const n = parseFloat(String(v ?? '').replace(',', '.')); return Number.isFinite(n) ? n : null; };
export const norm360 = (b) => ((b % 360) + 360) % 360;

export function crossBearing(p1, b1, p2, b2) {
  const f1 = p1[0] * R, l1 = p1[1] * R, f2 = p2[0] * R, l2 = p2[1] * R, t13 = b1 * R, t23 = b2 * R;
  const d12 = 2 * Math.asin(Math.sqrt(Math.sin((f2 - f1) / 2) ** 2 + Math.cos(f1) * Math.cos(f2) * Math.sin((l2 - l1) / 2) ** 2));
  if (Math.abs(d12) < 1e-12) return null;
  const cl = (x) => Math.min(1, Math.max(-1, x));
  const ta = Math.acos(cl((Math.sin(f2) - Math.sin(f1) * Math.cos(d12)) / (Math.sin(d12) * Math.cos(f1))));
  const tb = Math.acos(cl((Math.sin(f1) - Math.sin(f2) * Math.cos(d12)) / (Math.sin(d12) * Math.cos(f2))));
  const east = Math.sin(l2 - l1) > 0;
  const t12 = east ? ta : 2 * Math.PI - ta, t21 = east ? 2 * Math.PI - tb : tb;
  const a1 = t13 - t12, a2 = t21 - t23;
  if ((Math.sin(a1) === 0 && Math.sin(a2) === 0) || Math.sin(a1) * Math.sin(a2) < 0) return null;
  const c3 = -Math.cos(a1) * Math.cos(a2) + Math.sin(a1) * Math.sin(a2) * Math.cos(d12);
  const d13 = Math.atan2(Math.sin(d12) * Math.sin(a1) * Math.sin(a2), Math.cos(a2) + Math.cos(a1) * c3);
  if (d13 <= 0 || d13 * 6371000 > 50000) return null;
  const f3 = Math.asin(Math.sin(f1) * Math.cos(d13) + Math.cos(f1) * Math.sin(d13) * Math.cos(t13));
  const dl = Math.atan2(Math.sin(t13) * Math.sin(d13) * Math.cos(f1), Math.cos(d13) - Math.sin(f1) * Math.sin(f3));
  return [f3 / R, (((l1 + dl) / R + 540) % 360) - 180];
}

// angle between the two bearing lines (0–180°)
export const cutAngle = (b1, b2) => { const x = norm360(b1 - b2); return x > 180 ? 360 - x : x; };

// one compass reading from the phone sensor (null if unavailable)
export function readCompass() {
  return new Promise((res) => {
    const ev = 'ondeviceorientationabsolute' in window ? 'deviceorientationabsolute' : 'deviceorientation';
    let done = false;
    const end = (v) => { if (done) return; done = true; window.removeEventListener(ev, h); res(v); };
    const h = (e) => {
      const v = e.webkitCompassHeading != null ? e.webkitCompassHeading : e.alpha != null && (e.absolute || ev === 'deviceorientationabsolute') ? 360 - e.alpha + (window.screen?.orientation?.angle || 0) : null;
      if (v != null) end(Math.round(norm360(v)));
    };
    const start = () => { window.addEventListener(ev, h); setTimeout(() => end(null), 2500); };
    const D = window.DeviceOrientationEvent;
    if (!D) return res(null);
    if (typeof D.requestPermission === 'function') D.requestPermission().then((s) => (s === 'granted' ? start() : res(null))).catch(() => res(null));
    else start();
  });
}
